import React from "react";
import Header from "../Components/Header";
import Dashboardlayout from "../Components/Dashboardlayout";
import Header1 from "../Components/Header1";

const Dashboard = () => {
  return (
    <div className="w-full flex justify-center">
      <div className="w-full flex justify-center">
        <div className="flex flex-col w-full">
          <div className="w-full flex flex-col items-center">
            <div className="w-full bg-white flex justify-center sticky top-0 bg-white z-20 border-b-[1px] border-gray-200">
              <div className="2xl:container w-full ">
                <Header />
              </div>
            </div>
            <div className=" bg-404A52 w-full flex justify-center sticky top-20 z-10">
              <div className="2xl:container w-full">
                <Header1 />
              </div>
            </div>
            <div className="2xl:container w-full flex justify-center">
              <Dashboardlayout />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
